<template>
  <BreadCrumb PageTitle="Demandes RIB" />
  <RibRequests />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
import RibRequests from "../../../components/Customers/Demandes/RibRequests.vue";

export default defineComponent({
  name: "RibRequestsPage",
  components: {
    BreadCrumb,
    RibRequests,
  },

   
});
</script>